var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 12 5.188 6 12 6C12.947 6 13.839 6.121 14.678 6.322L8.36 12.64C8.12532 12.125 8.00262 11.566 8 11C8 10.063 8.335 9.213 8.875 8.531C6.483 9.343 4.661 10.916 3.621 12C4.50793 12.9232 5.5094 13.7291 6.601 14.398L5.148 15.851C2.497 14.13 1 12 1 12ZM23 12C23 12 18.812 18 12 18C11.054 18 10.164 17.876 9.324 17.677L5 22L3.5 20.5L20.5 3.5L22 5L18.853 8.147C21.501 9.869 23 12 23 12ZM20.385 12.006C19.4977 11.0789 18.4936 10.2711 17.398 9.603L16 11C16 12.0609 15.5786 13.0783 14.8284 13.8284C14.0783 14.5786 13.0609 15 12 15L11.053 15.947C11.363 15.978 11.677 16 12 16C15.978 16 18.943 13.522 20.385 12.006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide24);
export default __webpack_public_path__ + "static/media/Hide24.45993273dde465141ec8bdb145559092.svg";
export { ForwardRef as ReactComponent };